import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const e = "partner_links";
class n extends s {
  /**
   * Retrieves the list of partner links.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/partner_links`
   *
   * @returns {Promise<GetPartnerLinksReceivedData>} A promise containing the partner link data.
   */
  getPartnerLinks = async () => {
    const { data: t } = await this.get(e);
    return t;
  };
}
export {
  n as PartnerLink,
  e as RESOURCE_URI
};
